import react from 'react';
import {
  HANDLE_PROJECTS,
  SET_TEMPLATE,
  HANDLE_SOURCE_DATA,
  HANDLE_CARD_INFO,
  RESET_STORE,
  HANDLE_EDIT_MODE,
  HANDLE_REPORT_KEY,
  HANDLE_TEMPLATE_ID,
  HANDLE_TRIGGER_INFO,
  HANDLE_SLACK_DATA,
  HANDLE_REPORT_ACCESS_DATA,
  HANDLE_CARD_TEMPLATE_ID,
  HANDLE_ISSUE_CARD_INFO,
  HANDLE_APPEARANCE_INFO,
  HANDLE_SORTLIST_DATA,
  HANDLE_ISSUE_API_DATA,
  HANDLE_REPORT_OPTIONS,
  SET_INITIAL_SORTLIST_DATA,
  HANDLE_SEND_NOTIFICATION,
} from './types';

export const handleSelectedProject = (projects) => {
  // console.log('hello ankit', projects);
  return {
    type: HANDLE_PROJECTS,
    selectedProjectsForReport: projects,
  };
};

export const setTemplate = (template) => {
  return {
    type: SET_TEMPLATE,
    template: template,
  };
};

export const handleSourceDataChange = (key, value, data) => {
  //   console.log('handle fn', key, value, data);
  return {
    type: HANDLE_SOURCE_DATA,
    sourceData: { key, value, data },
  };
  // setSourceData({ ...sourceData, ...data });
};

export const cardInfo = (data) => {
  // console.log('CARD INFO', data);

  if (data && !data.hasOwnProperty('report_theme')) {
    data.report_theme = 'dark';
  }
  return { type: HANDLE_CARD_INFO, cardInfo: data || {} };
};
export const card_template_id = (data) => {
  //   console.log(data);
  return { type: HANDLE_CARD_TEMPLATE_ID, data: data };
};

export const resetStore = () => {
  return { type: RESET_STORE };
};

export const handleEditMode = (data) => {
  return { type: HANDLE_EDIT_MODE, mode: data };
};

export const handleReportKey = (data) => {
  return { type: HANDLE_REPORT_KEY, key: data };
};
export const handleTemplateFormat = (data) => {
  return { type: HANDLE_TEMPLATE_ID, template_id: data };
};

export const triggerInfo = (data) => {
  // console.log('triggerInfo fun running \n\n', data);
  return { type: HANDLE_TRIGGER_INFO, data: data };
};
export const slackInfo = (data) => {
  // console.log('slack data ', data);
  return { type: HANDLE_SLACK_DATA, data: data };
};

export const accessInfo = (data) => {
  return { type: HANDLE_REPORT_ACCESS_DATA, data: data };
};

export const handleIssueCardConfigChanges = (data) => {
  return { type: HANDLE_ISSUE_CARD_INFO, data: data };
};

export const handleAppearanceData = (data, isColorChange) => {
  // console.log('appearance Data', data);
  return { type: HANDLE_APPEARANCE_INFO, appearanceData: data };
};
export const setGraphColors = (data) => {
  // console.log('appearance Data', data);
  return { type: 'SET_REPORT_COLORS', graphColors: data };
};

export const handleSortListData = (data) => {
  // console.log(data)
  return { type: HANDLE_SORTLIST_DATA, sortListData: data };
};

export const setInitialSortListData = (data) => {
  return {
    type: SET_INITIAL_SORTLIST_DATA,
    initialSortListData: JSON.parse(JSON.stringify(data)),
  };
};

export const handleIssueApiData = (data) => {
  // console.log(data)
  return { type: HANDLE_ISSUE_API_DATA, issueApiData: data };
};
export const handleReportOptions = (data) => {
  // console.log(data)
  return { type: HANDLE_REPORT_OPTIONS, reportOptions: data };
};

export const handleSendNotifications = (data) => {
  return { type: HANDLE_SEND_NOTIFICATION, data: data };
};
